import React from "react";
import { ImageSection } from '../../components/ImageSection';

export const CollegeInfrastructure = () => {
    return(
        <div>
        <ImageSection/>
        </div>
    )
}